import {
  queryGoodsEvaluateApi,
  toppingGoodsEvaluateApi,
  deleteGoodsEvaluateApi,
  queryOrderEvaluationListApi,
  deleteOrderEvaluationApi,
  queryShopEvaluationListApi,
  deleteShopEvaluationApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  查询菜品评价
  async queryGoodsEvaluateAction(context, param) {
    const res = await queryGoodsEvaluateApi(param)
    return res
  },
  //  置顶商品评价
  async toppingGoodsEvaluateAction(context, param) {
    const res = await toppingGoodsEvaluateApi(param)
    return res
  },
  //  删除商品评价
  async deleteGoodsEvaluateAction(context, param) {
    const res = await deleteGoodsEvaluateApi(param)
    return res
  },
  //  查询订单评价列表
  async queryOrderEvaluationListAction(context, param) {
    const res = await queryOrderEvaluationListApi(param)
    return res
  },
  //  删除订单评价
  async deleteOrderEvaluationAction(context, param) {
    const res = await deleteOrderEvaluationApi(param)
    return res
  },
  //  查询门店评价列表
  async queryShopEvaluationListAction(context, param) {
    const res = await queryShopEvaluationListApi(param)
    return res
  },
  //  删除门店评价
  async deleteShopEvaluationAction(context, param) {
    const res = await deleteShopEvaluationApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
